<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16 3C16 2.44772 15.5523 2 15 2H3C2.44772 2 2 2.44772 2 3V15C2 15.5523 2.44772 16 3 16H15C15.5523 16 16 15.5523 16 15V3ZM14 4H4V14H14V4Z"
      fill="currentColor"
    />
    <path
      d="M22 9C22 8.44772 21.5523 8 21 8H18V10H20V20H10V18H8V21C8 21.5523 8.44772 22 9 22H21C21.5523 22 22 21.5523 22 21V9Z"
      fill="currentColor"
    />
  </svg>
</template>
